import { BRAND_LEGAL_NAME, BRAND_SHORT_NAME } from '../constants/brand.js';

export const DEFAULT_DOCUMENT_TITLE = `${BRAND_SHORT_NAME} | ${BRAND_LEGAL_NAME}`;

export function formatDocumentTitle(pageTitle) {
  const text = String(pageTitle ?? '').trim();
  if (!text) return DEFAULT_DOCUMENT_TITLE;
  return `${text} | ${BRAND_SHORT_NAME}`;
}
